import React from "react";
import { MapPin, Building2 } from "lucide-react";

const REGIONS = [
    { name: "St. Gallen", cities: "Stadt SG · Wil · Gossau · Rorschach · Flawil" },
    { name: "Thurgau", cities: "Wängi · Frauenfeld · Weinfelden · Kreuzlingen · Amriswil" },
    { name: "Appenzell Innerrhoden", cities: "Appenzell · Gonten · Oberegg" },
    { name: "Appenzell Ausserrhoden", cities: "Herisau · Teufen · Trogen · Speicher" },
    { name: "Zürich", cities: "Stadt ZH · Bülach · Dietikon · Uster · Dübendorf" },
    { name: "Winterthur", cities: "Winterthur · Wiesendangen · Seuzach · Pfäffikon ZH" },
    { name: "Schaffhausen", cities: "Stadt SH · Neuhausen · Stein am Rhein" },
    { name: "Zürichsee / Rapperswil", cities: "Rapperswil-Jona · Wetzikon · Hinwil" },
];

export default function ServiceArea() {
    return (
        <section id="einsatzgebiet" className="py-20 lg:py-28 bg-white" data-testid="service-area-section">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="max-w-3xl mb-12">
                    <span className="overline mb-4 inline-block">Einsatzgebiet</span>
                    <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl text-[#1A365D] tracking-tight">
                        Wir sind in der <span className="text-[#16A34A]">ganzen Ostschweiz</span> für Sie da
                    </h2>
                    <p className="mt-5 text-lg text-[#64748B]">
                        Bürostandort in Wängi (TG) — flexibel im Einsatz in St. Gallen, Thurgau, beiden Appenzell, Zürich, Winterthur, Schaffhausen und am Zürichsee bis Rapperswil.
                    </p>
                </div>

                {/* Office + map */}
                <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-6 mb-10">
                    <div className="rounded-3xl bg-gradient-to-br from-[#1A365D] to-[#0B1B33] text-white p-8 lg:p-10 relative overflow-hidden" data-testid="office-card">
                        <div className="absolute -bottom-10 -right-10 w-48 h-48 rounded-full bg-[#16A34A]/20 blur-3xl" />
                        <div className="relative">
                            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#16A34A] text-white text-xs font-bold uppercase tracking-wider mb-5">
                                <Building2 className="w-3.5 h-3.5" /> Büro-Standort
                            </div>
                            <h3 className="font-display font-bold text-2xl mb-3">Privathilfe.ch</h3>
                            <div className="text-white/90 space-y-1.5 text-base">
                                <div>Feldäckerweg 3</div>
                                <div>9545 Wängi</div>
                                <div className="text-white/60 text-sm mt-2">Kanton Thurgau, Schweiz</div>
                            </div>
                            <a
                                href="https://www.google.com/maps/search/?api=1&query=Feld%C3%A4ckerweg+3%2C+9545+W%C3%A4ngi"
                                target="_blank"
                                rel="noreferrer"
                                data-testid="office-maps-link"
                                className="inline-flex items-center gap-2 mt-6 text-sm font-semibold text-[#4ADE80] hover:text-white transition-colors"
                            >
                                In Google Maps öffnen <MapPin className="w-4 h-4" />
                            </a>
                        </div>
                    </div>

                    <div className="rounded-3xl overflow-hidden border border-slate-200 shadow-sm" data-testid="office-map">
                        <iframe
                            title="Privathilfe.ch Bürostandort"
                            src="https://www.google.com/maps?q=Feld%C3%A4ckerweg+3%2C+9545+W%C3%A4ngi&output=embed"
                            width="100%"
                            height="100%"
                            style={{ border: 0, display: "block", minHeight: 320 }}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>
                </div>

                {/* Regions grid */}
                <div className="rounded-3xl border border-slate-200 bg-[#F8FAFC] p-6 md:p-10" data-testid="regions-grid">
                    <h3 className="font-display font-bold text-xl text-[#1A365D] mb-1">Unsere Servicegebiete</h3>
                    <p className="text-sm text-[#64748B] mb-6">Eine Auswahl der Orte — auch ausserhalb? Fragen Sie unverbindlich an.</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        {REGIONS.map((r) => (
                            <div key={r.name} className="rounded-2xl bg-white border border-slate-200 p-5 hover:border-[#16A34A]/40 transition-colors" data-testid={`region-${r.name.toLowerCase().replace(/\s+/g, "-")}`}>
                                <div className="flex items-center gap-2 mb-2">
                                    <MapPin className="w-4 h-4 text-[#16A34A]" />
                                    <h4 className="font-display font-bold text-[#1A365D]">{r.name}</h4>
                                </div>
                                <p className="text-xs text-[#64748B] leading-relaxed">{r.cities}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
